import { render } from "./SigninButton.vue?vue&type=template&id=7fa4c3c5&scoped=true"
import script from "./SigninButton.vue?vue&type=script&lang=js"
export * from "./SigninButton.vue?vue&type=script&lang=js"

import "./SigninButton.vue?vue&type=style&index=0&id=7fa4c3c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa4c3c5"]])

export default __exports__